/* eslint-disable no-bitwise */
const generatedGraphics: UserGraphicsType = {};

interface UserGraphicsType {
  [userId: string]: {
    [key in GraphicKey]?: string;
  };
}

export type GraphicKey = 'image' | 'color';

export const generateAvatarGraphics = (
  userId: string,
  userGraphics: string[],
  graphicKey: GraphicKey
) => {
  if (!generatedGraphics[userId]) {
    generatedGraphics[userId] = {};
  }

  let avatar = generatedGraphics[userId][graphicKey];

  if (!avatar) {
    let hash = 0;

    for (let i = 0; i < userId.length; i++) {
      hash = userId.charCodeAt(i) + ((hash << 5) - hash);
      hash = hash & hash;
    }

    avatar = userGraphics[Math.abs(hash) % userGraphics.length];
    generatedGraphics[userId][graphicKey] = avatar;
  }

  return avatar;
};
